// extracted by mini-css-extract-plugin
export default {"item":"Services_item__sJY6N","btn":"Services_btn__KBpso","description":"Services_description__kfnL6","text-large":"Services_text-large__h9N64","text":"Services_text__lQH+x"};